import React, { FunctionComponent } from 'react';
import { II18n } from '../../../models';
import { BrassButtonSharedPropsV1, BrassButtonSharedV1 } from './ButtonV1';
import { BrassIcon } from '../icon/Icon';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const BrassButtonDownloadV1: FunctionComponent<BrassButtonSharedPropsV1> = (
  props: BrassButtonSharedPropsV1,
) => (
  <BrassButtonSharedV1
    themeColor='primary'
    labelKey='download'
    tooltipKey='clickToDownload'
    translations={translations}
    icon={<BrassIcon icon={faDownload} />}
    {...props}
  />
);

const translations: II18n = {
  es: {
    download: 'Descarregar',
    clickToDownload: 'Haga clic para descarregar',
  },
  enUS: {
    download: 'Download',
    clickToDownload: 'Click to download',
  },
  ptBR: {
    download: 'Download',
    clickToDownload: 'Clique para fazer o download',
  },
};

export { BrassButtonDownloadV1 };
